import * as S from "../Style/Page/Social.style.js";
const PageTitle = (props) => {
  return (
    <S.PageTitle>
      <span></span>
      <div className="title">
        <div class="kor">{props.titleko}</div>
        <div class="eng">{props.titleeng}</div>
      </div>
      {props.link && <a href={props.link}>
        <div className="kor">@ 바로가기</div>
        <div className="eng">@ Link</div>
        </a>}
    </S.PageTitle>
  );
};

export default PageTitle;
